module.exports = __webpack_public_path__ + "fonts/Ki.8f9a1a6c.woff";